export default "__VITE_ASSET__512536b3__"